















































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ListDisplay from '@/components/common/modules/ListDisplay.vue';
import SelectNoVModel from '@/components/common/elements/SelectNoVModel.vue';
import AutoCreateForm from '@/components/form/AutoCreateForm.vue';
import Button from '@/components/common/elements/Button.vue';

@Component({
  components: {
    ListDisplay,
    SelectNoVModel,
    AutoCreateForm,
    Button
  }
})
export default class RateTable extends Vue {
  @Prop({ default: () => ({}) })
  private item: any;
  @Prop({ default: () => ({}) })
  private configurationTableData: any;

  @Prop({ default: '' })
  private displayInfomation!: string;

  get hasEstimateInformationPanelDatas() {
    return this.item && this.item.estimateInformationPanel.datas.length >= 9;
  }

  get estimateInformationPanelDatas() {
    if (!this.hasEstimateInformationPanelDatas) {
      return [];
    }
    return this.item.estimateInformationPanel.datas.slice(5, 9);
  }

  // セレクト内選択データ
  selectValue = {};
  // テキストフィールドデータ
  textValue = '';

  @Emit('tabChildrenEventRelay')
  private catchInputRelay(response: any) {
    response.functionName = 'catchInputRelay';
    return response;
  }

  /**
   * 親コンポーネントにテキストフィールドで入力された行のアイテムをオブジェクトで返します
   * @module getData
   * @param inputValue - 入力値
   * @param inputName - 入力フィールド名
   * @param record - アイテム情報
   * @return { inputValue, inputName, itemIndex, record }
   */
  @Emit('tabChildrenEventRelay')
  getdataRelay(response: any) {
    response.functionName = 'getdataRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private clickItemAdditionButtonRelay(response: any) {
    response.functionName = 'clickItemAdditionButtonRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private clickDownloadButtonEventRelay(response: any) {
    response.functionName = 'clickDownloadButtonEventRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private masterSelectEventRelay(response: any) {
    response.functionName = 'masterSelectEventRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private clickCheckBoxEventRelay(response: any) {
    response.functionName = 'clickCheckBoxEventRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  public changeSelectTemplete(response: any) {
    response.functionName = 'changeSelectTemplete';
    this.computedValue = response.value.value;

    return response;
  }

  /**
   * 端数調整ボタン押下時の情報を親コンポーネントに返す
   * @module clickFractionRounding
   * @param {any} response - 子コンポーネントより渡される値
   * @return response
   */
  @Emit('clickFractionRounding')
  clickFractionRounding(response: any) {
    return response;
  }

  /**
   * 端数調整解除ボタン押下時の情報を親コンポーネントに返す
   * @module clickUndoFractionRounding
   * @param {any} response - 子コンポーネントより渡される値
   * @return response
   */
  @Emit('clickUndoFractionRounding')
  clickUndoFractionRounding(response: any) {
    return response;
  }

  /**
   * 金額調整ボタン押下時の情報を親コンポーネントに返す
   * @module clickRecalc
   * @param {any} response - 子コンポーネントより渡される値
   * @return response
   */
  @Emit('clickRecalc')
  clickRecalc(response: any) {
    return response;
  }

  /**
   * コンポーネント内でテキストフィールドへの値反映を完結するため、
   * 算出プロパティを設定する（直接propsを変更できないため）
   */

  get computedValue() {
    return this.textValue;
  }
  set computedValue(newValue) {
    this.textValue = newValue;
  }
}
